import Vue from 'vue'

export const LongTermOptionsMutations = {
  setLongTermOptions: (state, payload) => { state.longTermOptions = payload },
  updateLTO: (state, option) => {
    const optionList = state.longTermOptions[option.category]
    const optionIndex = optionList.findIndex(o => o.identifier === option.identifier)
    Vue.set(optionList, optionIndex, { ...option, ...optionList[optionIndex] })
  },
}
